const menus = [
    {
        id: 1,
        tomenu: "#testimonial",
        namemenu: "Appreciations"
    },
    {
        id: 2,
        tomenu: "#about",
        namemenu: "About"
        
    },
    {
        id: 3,
        tomenu: "#services",
        namemenu: "Skills"
    },
    {
        id: 4,
        tomenu: "#portfolio",
        namemenu: "Projects"
    },
    
];



export default menus ;